export const termsAndConditionsUrl = (currentIsoCountry: string) => {
  switch (currentIsoCountry) {
    case 'br':
      return 'https://factorialhr.com.br/termos-e-condicoes-programa-de-indicacoes'
    default:
      return 'https://factorialhr.com/terms-and-conditions-referral-program'
  }
}
export const reward = (currentIsoCountry: string, step: string) => {
  switch (currentIsoCountry) {
    case 'ar':
    case 'bo':
    case 'bs':
    case 'bz':
    case 'cl':
    case 'co':
    case 'cr':
    case 'do':
    case 'ec':
    case 'gt':
    case 'hn':
    case 'jm':
    case 'ky':
    case 'mx':
    case 'ni':
    case 'pa':
    case 'pe':
    case 'pr':
    case 'py':
    case 'sv':
    case 'uy':
    case 've':
      return { 1: 'MX$ 50000', 2: 'MX$ 15000', 3: 'MX$ 9000', 4: 'MX$ 5000' }[step]
    case 'us':
      return { 1: '$3500', 2: '$1200', 3: '$700', 4: '$300' }[step]
    case 'br':
      return { 1: '$ 835', 2: '$ 420', 3: '$ 210', 4: '$ 210' }[step]
    case 'gb':
      return { 1: '£3500', 2: '£1200', 3: '£700', 4: '£300' }[step]
    case 'de':
    case 'fr':
      return { 1: '3500€', 2: '1200€', 3: '700€', 4: '300€' }[step]
    case 'it':
    case 'pt':
    case 'es':
      return { 1: '3000€', 2: '1000€', 3: '600€', 4: '200€' }[step]
    default:
      return { 1: '300€', 2: '600€', 3: '1000€', 4: '3000€' }[step] || 0
  }
}

export const isCountryAvailable = (currentIsoCountry: string) => {
  const availableCountries = ['es', 'it', 'pt', 'de', 'fr']
  return availableCountries.includes(currentIsoCountry)
}

type ValidLocale = 'pt-br' | 'pt' | 'it' | 'en-gb' | 'en-us' | 'fr' | 'de' | 'es'

// NB: The actual URL is /referral/some-token, provided by the feature
export const referralUrlForLocale = (locale: ValidLocale | string) => {
  switch (locale) {
    case 'de':
      return 'https://factorialhr.de/referral'
    case 'en-gb':
      return 'https://factorialhr.co.uk/referral'
    case 'pt-br':
      return 'https://factorialhr.com.br/referral'
    case 'pt':
      return 'https://factorialhr.pt/referral'
    case 'it':
      return 'https://factorial.it/referral'
    case 'fr':
      return 'https://factorial.fr/referral'
    case 'es':
      return 'https://factorial.es/referral'
    case 'es-mx':
      return 'https://factorial.mx/referral'
    case 'en-us':
    default:
      return 'https://factorialhr.com/referral'
  }
}
